import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// ============================================================
// 접수 알림 팝업
//
// [하는 일]
//   사이트에 들어올 때 미처리 접수가 있는지 확인하고,
//   있으면 팝업으로 알린다. [접수함 보기] 를 누르면 이동한다.
//
// [왜 필요한가]
//   일반인 접수는 블로그·QR 로 언제 들어올지 모른다.
//   접수관리 탭에 직접 들어가 보지 않으면 알 수 없어
//   연락이 늦어질 수 있다.
//
// [매번 뜨지 않게]
//   같은 날 이미 닫았으면 다시 띄우지 않는다.
//   단, 접수 건수가 늘어나면 새로 알린다.
//   (localStorage 에 "날짜:건수" 를 남겨 비교한다)
//
// [연관]
//   backend/routes/staffIntake.js  /submissions/count
//   pages/SubmissionPage.jsx       접수관리 화면
// ============================================================

const SEEN_KEY = "submission_alert_seen";

export default function SubmissionAlert() {
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [show, setShow]   = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;   // 비로그인은 확인하지 않는다

    // 화면이 뜨자마자 부르면 다른 요청과 겹치므로 잠깐 뒤에 확인한다
    const t = setTimeout(async () => {
      try {
        const r = await fetch("/api/submissions/count", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!r.ok) return;              // 권한 없으면 조용히 넘어간다
        const j = await r.json();
        const c = Number(j.count) || 0;
        if (c <= 0) return;

        // 오늘 이미 본 건수와 같으면 띄우지 않는다
        const today = new Date().toISOString().slice(0, 10);
        const seen  = localStorage.getItem(SEEN_KEY);      // "2026-08-27:3"
        if (seen === `${today}:${c}`) return;

        setCount(c);
        setShow(true);
      } catch (_) {
        // 네트워크 오류는 무시한다. 알림은 부가 기능이므로
        // 실패해도 사용에 지장이 없어야 한다.
      }
    }, 1500);

    return () => clearTimeout(t);
  }, []);

  const close = () => {
    const today = new Date().toISOString().slice(0, 10);
    localStorage.setItem(SEEN_KEY, `${today}:${count}`);
    setShow(false);
  };

  const go = () => {
    close();
    navigate("/submissions");
  };

  if (!show) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: "rgba(0,0,0,.45)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 20,
    }}>
      <div style={{
        background: "#fff", borderRadius: 14, padding: "28px 24px",
        maxWidth: 340, width: "100%", textAlign: "center",
        boxShadow: "0 10px 40px rgba(0,0,0,.25)",
      }}>
        <div style={{
          width: 56, height: 56, lineHeight: "56px", margin: "0 auto 18px",
          background: "#fff1f0", color: "#d32f2f", borderRadius: "50%",
          fontSize: 26, fontWeight: 800,
        }}>
          {count}
        </div>

        <h3 style={{ fontSize: 18, margin: "0 0 10px" }}>
          새 매물 접수 {count}건
        </h3>
        <p style={{ color: "#777", fontSize: 14, lineHeight: 1.7, margin: "0 0 22px" }}>
          아직 처리하지 않은 접수가 있습니다.<br />
          확인 후 승인하거나 반려해 주세요.
        </p>

        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={close} style={{
            flex: 1, minHeight: 46, background: "#f2f2f2", color: "#555",
            border: 0, borderRadius: 8, fontSize: 15, cursor: "pointer",
          }}>
            나중에
          </button>
          <button onClick={go} style={{
            flex: 2, minHeight: 46, background: "#1a2b4a", color: "#fff",
            border: 0, borderRadius: 8, fontSize: 15, fontWeight: 700,
            cursor: "pointer",
          }}>
            접수함 보기
          </button>
        </div>
      </div>
    </div>
  );
}